import "./index.css"

import App from "./TodoApp"
import React from "react"
import ReactDOM from "react-dom"

ReactDOM.render(<App />, document.getElementById("root"))
